import React from "react";
import { Bell, AlertTriangle, CheckCircle2, Mail } from "lucide-react";

const STATUS_CONFIG = {
  on_track: { Icon: CheckCircle2, color: "var(--crm-success)", label: "Email on track" },
  due_soon: { Icon: Bell, color: "var(--crm-warning, #B45309)", label: "Email due soon" },
  missed: { Icon: AlertTriangle, color: "var(--crm-danger)", label: "Email follow-up missed" },
  escalated: { Icon: AlertTriangle, color: "var(--crm-danger)", label: "Email follow-up escalated" },
  replied: { Icon: Mail, color: "var(--crm-primary)", label: "Vendor replied" },
};

export default function EmailFollowUpPill({ summary }) {
  if (!summary?.worstStatus) return null;
  const cfg = STATUS_CONFIG[summary.worstStatus] || STATUS_CONFIG.on_track;
  const Icon = cfg.Icon;
  let text = cfg.label;
  if (summary.nextDueAt && (summary.worstStatus === "on_track" || summary.worstStatus === "due_soon")) {
    text = `${cfg.label} · ${new Date(summary.nextDueAt).toLocaleDateString()}`;
  }
  if (summary.missedCount > 1) text += ` (${summary.missedCount})`;

  return (
    <span
      title={summary.nextDueAt ? new Date(summary.nextDueAt).toLocaleString() : text}
      style={{ display: "inline-flex", alignItems: "center", gap: 3, fontSize: 11, fontWeight: 600, color: cfg.color }}
    >
      <Icon size={11} /> {text}
    </span>
  );
}
